export class AttributeIdAndStyle {
    id: string;
    defaultValue: string;
    keyCol: KeyCol;
    valCol: ValCol;
    label: string;
    placeHolder?: string;
    constructor(id: string, defaultValue: string, keyCol: KeyCol, valCol: ValCol, label?: string, placeHolder?: string) {
        this.id = id;
        this.defaultValue = defaultValue;
        this.keyCol = keyCol;
        this.valCol = valCol;
        if (label) {
            this.label = label;
        }
        if (placeHolder) {
            this.placeHolder = placeHolder;
        }
    }
}

export class KeyCol {
    md: number;
    sm: number;
    xs: number;
    constructor(md: number, sm: number, xs: number) {
        this.md = md;
        this.sm = sm;
        this.xs = xs;
    }
}

export class ValCol {
    md: number;
    sm: number;
    xs: number;
    constructor(md: number, sm: number, xs: number) {
        this.md = md;
        this.sm = sm;
        this.xs = xs;
    }
}

